import { Link } from '@tanstack/react-router'
import type { ReactNode } from 'react'
import type { LandingPage } from '../types'

/**
 * Links to a landing page at its e-chalupy-style URL under `/pobyty`:
 * single-dimension pages at `/pobyty/<slug>`, combos nested region-first at
 * `/pobyty/<region>/<dimension>`. Centralizes the route/params split so callers
 * just pass a page.
 */
export function LandingLink({
  page,
  className,
  children,
}: {
  page: LandingPage
  className?: string
  children: ReactNode
}) {
  if (page.kind === 'combo' && page.comboRegion && page.comboBase) {
    return (
      <Link
        to="/pobyty/$landingSlug/$comboSlug"
        params={{ landingSlug: page.comboRegion, comboSlug: page.comboBase }}
        className={className}
      >
        {children}
      </Link>
    )
  }

  return (
    <Link to="/pobyty/$landingSlug" params={{ landingSlug: page.slug }} className={className}>
      {children}
    </Link>
  )
}
